var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8228 15.8828C13.7122 16.7248 12.3234 17.1138 10.9371 16.9711C9.55074 16.8285 8.27024 16.1649 7.35438 15.1144C6.43851 14.0639 5.95559 12.7049 6.00321 11.3121C6.05084 9.91922 6.62545 8.59639 7.61092 7.61092C8.59639 6.62545 9.91922 6.05084 11.3121 6.00321C12.7049 5.95559 14.0639 6.43851 15.1144 7.35438C16.1649 8.27024 16.8285 9.55074 16.9711 10.9371C17.1138 12.3234 16.7248 13.7122 15.8828 14.8228L18.5298 17.4698C18.8228 17.7628 19.0598 18.0598 18.5298 18.5298C17.9998 18.9998 17.7628 18.8228 17.4698 18.5298L14.8228 15.8828ZM11.4998 15.4998C12.5607 15.4998 13.5781 15.0784 14.3282 14.3282C15.0784 13.5781 15.4998 12.5607 15.4998 11.4998C15.4998 10.4389 15.0784 9.42153 14.3282 8.67138C13.5781 7.92123 12.5607 7.49981 11.4998 7.49981C10.4389 7.49981 9.42153 7.92123 8.67138 8.67138C7.92123 9.42153 7.49981 10.4389 7.49981 11.4998C7.49981 12.5607 7.92123 13.5781 8.67138 14.3282C9.42153 15.0784 10.4389 15.4998 11.4998 15.4998Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c962db8a8f2d80c03bc6530e519f1f92.svg";
export { ForwardRef as ReactComponent };